"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appStateSchema = exports.HUB_MODULES = void 0;

var _zod = require("zod");

var HUB_MODULES = ['Community', 'Education', 'Event', 'Group', 'Ideation', 'KnowledgeBase', 'ProductUpdates', 'Spaces'];
exports.HUB_MODULES = HUB_MODULES;

var appStateSchema = _zod.z.object({
  appName: _zod.z.enum(['hub', 'forum', 'control']).nullable(),
  activeHubModules: _zod.z.array(_zod.z.enum(HUB_MODULES)),
  activeEntities: _zod.z.record(_zod.z.boolean()),
  language: _zod.z.string(),
  baseUrl: _zod.z.string().optional(),
  isEmbedded: _zod.z.boolean().optional()
}).default({
  appName: null,
  activeHubModules: [],
  activeEntities: {},
  language: 'en-US',
  baseUrl: '',
  isEmbedded: false
});

exports.appStateSchema = appStateSchema;